import React from 'react';
import { Typography, Card, Row, Col, Space } from 'antd';
import { TeamOutlined } from '@ant-design/icons';
import moment from 'moment';

import { useFormerTeamsList } from '../../models/useFormerTeamsList';
import { getAppBaseUrl } from '../../utils/URLBuilder';

const { Paragraph, Text } = Typography;

const URLPath = getAppBaseUrl();

export const FormerTeamsSection = ({ clientId, baseURLs, isAdmin }) => {
    const formerTeams = useFormerTeamsList(clientId);

    if (!isAdmin || !clientId) return null;
    if (formerTeams === null || formerTeams.length === 0) return null;

    return (
        <div style={{ marginBottom: '30px', paddingTop: '16px' }}>
            <Paragraph style={{ margin: 0, marginBottom: '16px', fontWeight: 'bold' }}>
                Former Teams ({formerTeams.length})
            </Paragraph>
            <Paragraph type="secondary" style={{ margin: 0, marginBottom: '12px', fontSize: 12 }}>
                Teams this client used to be a member of (now deleted/left)
            </Paragraph>
            <Row gutter={[16, 16]}>
                {formerTeams.map((item) => {
                    const ownerId = item.teamOwnerClientId;
                    const fullHref = item.teamId && ownerId
                        ? `${URLPath}/admin/clients/${ownerId}/teams/${item.teamId}`
                        : null;

                    return (
                        <Col key={`former-${item.teamId}-${item.id}`} xs={24} sm={12} md={8} lg={6}>
                            <Card
                                size="small"
                                style={{
                                    textAlign: 'left',
                                    border: '1px solid #d9d9d9',
                                    background: '#fafafa',
                                }}
                            >
                                <Space direction="vertical" size={4} style={{ width: '100%' }}>
                                    <Space>
                                        <TeamOutlined style={{ color: '#999' }} />
                                        <Text strong>{item.teamName || item.teamId || 'Unknown Team'}</Text>
                                    </Space>
                                    <Text type="secondary" style={{ fontSize: 12 }}>
                                        Left: {item.updatedAt
                                            ? moment(item.updatedAt.toMillis ? item.updatedAt.toMillis() : item.updatedAt).format('YYYY-MM-DD HH:mm')
                                            : '-'}
                                    </Text>
                                    {fullHref && (
                                        <a href={fullHref} target="_blank" rel="noopener noreferrer">
                                            View team →
                                        </a>
                                    )}
                                </Space>
                            </Card>
                        </Col>
                    );
                })}
            </Row>
        </div>
    );
};
